import React, {PureComponent} from 'react';
import {isUSD} from 'app/utils/ShopItemPriceFormat';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

interface ShopItemDiscountProps {
    sale: number | null
    sale_money: number | null
    currency: string
}

export default class ShopItemDiscount extends PureComponent<ShopItemDiscountProps> {
    render(): React.ReactNode {
        const {sale, sale_money, currency} = this.props;

        if (!(sale && !isUSD(currency)) && !(sale_money && isUSD(currency))) {
            return null;
        }
        return <div className="sale">
            <SpriteIcon name="#svg-sale-label" size={{height: 24, width: 24}}/>
            <div className="sale__text">
                <span>{isUSD(currency) ? sale_money : sale}%</span>
            </div>
        </div>;
    }
}
